module.exports = __webpack_public_path__ + "img/symbol_pfeilundbogen@2x.c1816cf.jpg";